import App from '@/models/App'

export default class Ordering extends App {
    static get entity() {
        return 'orderings'
    }

    static one() {
        return this.query().first()
    }

    static shipAccountType(shipId) {
        if (this.one().accountType === 'OWNER') {
            return this.one().accountType;
        } else {
            return this.one().ship.find(ship => ship.id === shipId).accountType;
        }
    }

    static fields() {
        return {
            hasAccount: this.attr(false),
            accountType: this.attr(null),
            ship: this.attr([]),
            orderingAccountIds: this.attr([]),
        }
    }

    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/env/ordering`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'ordering',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
